import PropTypes from 'prop-types';

const categoriesPropType = PropTypes.arrayOf(PropTypes.string);

export { categoriesPropType };
